module.exports = __webpack_public_path__ + "img/16_44.c340788e.png";